import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=316d6f47"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports